/* this file is transformed by vux-loader */
/* eslint-disable */
/**
 * @Description: 正则表达式
 * @语法：regexp.test(str) 
 * @常用方法：
 * test() 方法检查字符串是否与给出的正则表达式模式相匹配，如果是则返回 true，否则就返回 false。
 */
export default {
  // 手机号（严谨）, 根据工信部2019年最新公布的手机号段
  phone: {
    name: '手机号码',
    rule: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
  },
  // 手机号(宽松), 只要是13,14,15,16,17,18,19开头即可
  phone_simple: {
    name: '手机号码',
    rule: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
  },
  // 只能输入数字
  number: {
    name: '数字',
    rule: /^[0-9]*$/
  },
  // 验证Email地址
  email: {
    name: '邮箱',
    rule: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  // 验证邮编
  postcode: {
    name: '邮编',
    rule: /^[1-9][0-9]{5}$/
  },
  IdCard: {
    name: '身份证号码',
    rule: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
  },
  name: {
    name: '姓名',
    rule: /^[A-Za-z\u4e00-\u9fa5][\w\._-]{0,44}$/
  },
  chinesename: {
    name: '姓名',
    rule: /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/
  },
  username: {
    name: '用户名',
    rule: /^[A-Za-z][\w\._-]{0,44}$/
  },
  // 中英文
  nameNE: {
    name: '姓名',
    rule: /^[\u4e00-\u9fa5]{2,4}$|^[\dA-Za-z_]{1,10}$/
  },
  // 6--18位的数字和字母组合
  password: {
    name: '密码',
    rule: /^(?:\d+|[a-zA-Z]+){6,18}$/
  },
  // 格式如：/abc/cba
  routerURL: {
    name: 'API-UR／页面URL',
    rule: /^\/\w+\/?\w*$/
  },
  date: {
    name: '日期',
    rule: /^[0-9]{4}[-/.][0-9]{2}[-/.][0-9]{2}$/
  },
  license: {
    name: '执业证号',
    rule: /^\d{24}|\d{}27$/
  },
  string_1_10: {
    name: '1-10位字符',
    rule: /^.{1,10}$/
  },
  number_gt_0: {
    name: '大于0数字',
    rule: /^[1-9][0-9]*$/
  },
  number_in_01: {
    name: '数字0或1',
    rule: /^[01]$/
  },
  number_in_4: {
    name: '数字4位以内',
    rule: /^[0-9]{1,4}$/
  }
};